import React from "react";
import Avatar1 from "../../../assets/images/DietPlans/Avatar1.svg";
import Avatar2 from "../../../assets/images/DietPlans/Avatar2.svg";
import Avatar3 from "../../../assets/images/DietPlans/Avatar3.svg";
import Avatar4 from "../../../assets/images/DietPlans/Avatar4.svg";

const avatarArray = [Avatar1, Avatar2, Avatar3, Avatar4];

const UnlockFeature = () => {
  return (
    <div className="unlock-main my-3 mb-0 p-4">
        <div className="unlock-feature mb-4">
          <h3 className="main-title">DR TRUST 360 PRO</h3>
          <h4>Unlock all Features to improve your overall health</h4>
          <p>Find diet plans that suit your health needs</p>
          <div className="d-flex align-items-start mb-3">
            {avatarArray.map((image, i) => {
              return (
                <img
                  key={i}
                  className="me-2 meet-experts-img"
                  src={image}
                  alt=""
                  loading="lazy"
                />
              );
            })}
          </div>
          <p className="meet-experts-description mb-0">
            & 12547+ lives transformed
          </p>
        </div>
      </div>
  );
};

export default UnlockFeature;
